// extracted by mini-css-extract-plugin
export default {"container":"emptyList_container__SHRR1","section-title":"emptyList_section-title__TtBG7"};